import { useOverlayActions, useUserActions } from '@store'
import { useTonConnectUI } from '@tonconnect/ui-react'

export const useClaim = () => {
    const [tonConnectUI] = useTonConnectUI()
    const { airdrop, checkIfClaimed } = useUserActions()
    const { setOverlayQueue } = useOverlayActions()
    
    async function claimJetton() {
        const claimInfo = await airdrop()
        if (!claimInfo?.claim_message){
            return false;
        }
        const claimMessage = claimInfo.claim_message
        const result =  await tonConnectUI.sendTransaction({
            validUntil: Math.floor(Date.now() / 1000) + 300, // 5 minutes
            messages: [
                {
                    address: claimMessage.address,
                    amount: claimMessage.amount,
                    payload: claimMessage.payload,
                    stateInit: claimMessage.state_init,
                },
            ],
        })
        if (result.boc) {
            setOverlayQueue([
              {
                type: 'transactionProcessing',
              },
            ])
            const deadline = Date.now() + 90_000
            while (Date.now() < deadline) {
                if (await checkIfClaimed()) return true
                await new Promise(r => setTimeout(r, 3000))
            }
        }
       
        return false;
    }
    return { claimJetton }
}